export default "__VITE_ASSET__DIXadFFe__"